module.exports = __webpack_public_path__ + "files/dac3760dd53001bd1637ee3bb1e4ed85.png";